import { Nav, NavItem, NavLink, Button, Col, Row } from "reactstrap";
import Select from "react-select";
import { FormattedMessage } from "react-intl";

function MobileAPLTabs({
  toggleCreatePeriod,
  periodsToSelect,
  period,
  activeTab,
  handleSelectPeriod,
  selectedPeriod,
  handleSetAplTab,
}) {
  return (
    <div>
      <div style={{ overflowX: "scroll", whiteSpace: "nowrap" }}>
        <Nav tabs className="bg-primary" style={{ display: "inline-block" }}>
          {period && (
            <>
              <NavItem style={{ margin: "auto 0", display: "inline-block" }}>
                <NavLink
                  className={
                    activeTab === 4 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(4)}
                >
                  <FormattedMessage id="AdministerPeriod" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0", display: "inline-block" }}>
                <NavLink
                  className={
                    activeTab === 1 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(1)}
                >
                  <FormattedMessage id="Presence" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0", display: "inline-block" }}>
                <NavLink
                  className={
                    activeTab === 2 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(2)}
                >
                  <FormattedMessage id="Workcard" />
                </NavLink>
              </NavItem>
              <NavItem style={{ margin: "auto 0", display: "inline-block" }}>
                <NavLink
                  className={
                    activeTab === 3 ? "active text-primary" : "text-white"
                  }
                  style={{ color: "white" }}
                  onClick={() => handleSetAplTab(3)}
                >
                  <FormattedMessage id="WorkcardFeed" />
                </NavLink>
              </NavItem>
            </>
          )}
        </Nav>
      </div>
      <Row>
        <Col>
          <Button
            outline
            className="ms-3 mt-3 apl_header_createNewButton"
            onClick={toggleCreatePeriod}
          >
            <FormattedMessage id="NewAplPeriod" />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="ms-3 mt-1" lg="4">
          <Select
            menuPortalTarget={document.body}
            styles={{
              padding: 0,
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPosition={"fixed"}
            options={periodsToSelect}
            value={
              selectedPeriod
                ? selectedPeriod
                : { value: null, label: "Välj period" }
            }
            onChange={(event) => {
              handleSelectPeriod(event);
            }}
            placeholder="Välj period"
          />
        </Col>
      </Row>
    </div>
  );
}

export default MobileAPLTabs;
